import { Suspense } from 'react';

import { ToastContainer } from '@/components/ui/Toast/ToastContainer';
import useMossSdk from '@/modules/moss/useMossSdk';
import { GlobalModalContainer } from '@/new_src/view/bootstrap/GlobalModalContainer';
import { useApplicationMaintenance } from '@/new_src/view/bootstrap/hooks/useApplicationMaintenance';
import useInitializingConfig from '@/new_src/view/bootstrap/hooks/useInitializingConfig';
import { useSyncBrowserHistory } from '@/new_src/view/bootstrap/hooks/useSyncBrowserHistory';
import Maintenance from '@/new_src/view/bootstrap/Maintenance';
import { useObservingOktaAuthentication } from '@/new_src/view/pages/SSO/Okta';
import { AuthLayerRouter } from '@/new_src/view/router/layer/Auth';

import LoadingSpinner from 'components/utility/LoadingSpinner';

export const Entry = () => {
  const isUnderMaintenance = useApplicationMaintenance();
  const { isLocaleInitialized, isAppInitialized } = useInitializingConfig();

  // sync global state with browser history
  useSyncBrowserHistory();
  useObservingOktaAuthentication();
  useMossSdk();

  // 서비스 점검시 렌더링, 레거시 로직이라 분석 필요
  if (isUnderMaintenance) {
    return <Maintenance />;
  }

  if (!isAppInitialized || !isLocaleInitialized) {
    return null;
  }

  return (
    <>
      <Suspense fallback={<LoadingSpinner />}>
        <AuthLayerRouter />
        <GlobalModalContainer />
        <ToastContainer />
      </Suspense>
    </>
  );
};
